import { render, staticRenderFns } from "./appMenu.vue?vue&type=template&id=c1240ccc&scoped=true"
import script from "./appMenu.js?vue&type=script&lang=js&external"
export * from "./appMenu.js?vue&type=script&lang=js&external"
import style0 from "./appMenu.vue?vue&type=style&index=0&id=c1240ccc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1240ccc",
  null
  
)

export default component.exports